import { styled, Tab, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator' : {
    height          : '5px',
    borderRadius    : '2px',
    backgroundColor : theme.palette.primary.blue1,
  },
}));

export const StyledTab = styled(Tab)({
  fontSize          : '32px',
  lineHeight        : '42px',
  fontWeight        : '700',
  fontFamily        : 'Montserrat',
  textTransform     : 'capitalize',
  color             : '#1E1E1E',
  opacity           : '0.3',
  '&:first-of-type' : {
    paddingLeft : '0px',
  },
  '&.Mui-selected' : {
    opacity : '1',
    color   : '#1E1E1E',
  },
});
